'use strict';

if (typeof window !== 'undefined') {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (fn) {
      return setTimeout(fn, 0);
    };
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-modal/lib/polyfill.js
// module id = 587
// module chunks = 0